export default ({ arrayHelpers: { push }, item: { id, name } }) =>
  push({
    readingTypeId: id,
  })
